import { createFeatureSelector, createSelector } from '@ngrx/store';
import { State, currentDateTimeFeatureKey } from '../reducers/current-date-time.reducer';

const selectCurrentDateTimeState = createFeatureSelector<State>(currentDateTimeFeatureKey);

export const getCurrentDateTime = createSelector(selectCurrentDateTimeState, state => state.currentDateTime);
